import React, { FC } from 'react'

import { styled } from '@linaria/react'

import { LogoLink } from 'components/block/Logo/LogoLink'
import { breakpoints } from 'components/designSystem/shared/breakpoints'

import {
  blockPadding,
  desktopWidth,
  mobileWidth,
} from './WaveBoarding.constants'
import { ChangeLanguageButton } from '../Onboarding/ChangeLanguageButton'

const Panel = styled.div`
  display: flex;
  justify-content: center;
  background: var(--pearl-soft);
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  margin-top: 15px;
  padding: 14px ${blockPadding};
  align-items: center;

  @media (min-width: ${breakpoints.mobile}px) {
    width: ${desktopWidth};
  }

  @media (max-width: ${breakpoints.mobile - 1}px) {
    width: ${mobileWidth};
  }
`

export const Navigation: FC = () => {
  return (
    <Panel>
      <Wrapper>
        <LogoLink />

        <ChangeLanguageButton />
      </Wrapper>
    </Panel>
  )
}
